<script setup>
import { contattiPage } from '@/graphql/queries/contatti.js'

definePageMeta({
  layout: 'default',
})

const { locale } = useI18n()

const variables = computed(() => ({
  locale: locale.value,
}))

const { data } = await useGraphql(contattiPage, variables)

if (!data.value.contatti) {
  throw createError({ statusCode: 404 })
}

const page = computed(() => data?.value.contatti)

const seo = computed(() => page?.value.seo || {})
useSeo(seo)
</script>

<template>
  <div class="azienda-page p-top-1a">
    <PagineContattiIntro v-if="page" />
  </div>
</template>
